import { supabase } from '@/core/database/supabase';
import type { QsDashboardStats } from '../types/construction-qs.types';

export const ConstructionQsStatsService = {
  async getDashboardStats(companyId: string, projectId?: string): Promise<QsDashboardStats> {
    let costQuery = supabase
      .from('construction_cost_entries')
      .select('actual_amount, cost_type')
      .eq('company_id', companyId);
    if (projectId) costQuery = costQuery.eq('project_id', projectId);
    const { data: costs } = await costQuery;

    let claimQuery = supabase
      .from('construction_payment_claims')
      .select('net_amount, status_code, claim_type')
      .eq('company_id', companyId);
    if (projectId) claimQuery = claimQuery.eq('project_id', projectId);
    const { data: claims } = await claimQuery;

    const actualCost = (costs || []).reduce((sum, c) => sum + (c.actual_amount || 0), 0);
    const reworkCost = (costs || []).filter(c => c.cost_type === 'rework').reduce((sum, c) => sum + (c.actual_amount || 0), 0);
    
    const claimedAmount = (claims || [])
      .filter(c => ['approved', 'paid'].includes(c.status_code))
      .reduce((sum, c) => sum + (c.net_amount || 0), 0);
    
    const variationAmount = (claims || [])
      .filter(c => c.claim_type === 'variation' && ['approved', 'paid'].includes(c.status_code))
      .reduce((sum, c) => sum + (c.net_amount || 0), 0);

    const pendingClaims = (claims || []).filter(c => c.status_code === 'submitted').length;

    return {
      totalContractValue: 2500000000, 
      totalActualCost: actualCost,
      totalClaimedAmount: claimedAmount,
      totalPaidAmount: claimedAmount * 0.9, 
      variationAmount: variationAmount,
      reworkAmount: reworkCost,
      pendingClaimsCount: pendingClaims,
      pendingVariationsCount: 2, 
      progressPercent: 65,
      budgetUtilization: (actualCost / 2500000000) * 100
    };
  }
};
